'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-dashboard-schedule-tooltip-template.html'));
var ChartDashboardScheduleController = function ChartDashboardScheduleController($scope, $rootScope, $filter, chartDashboardScheduleDataService, chartDashboardScheduleService, dashboardCommonService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d) {
      return d;
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, 'PERCENTAGE');
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var metrics = [];
      for (var label in d.metrics) {
        metrics.push({
          txt: label,
          val: rmNumberFormat(d.metrics[label])
        });
      }
      return tooltipTemplate({
        metrics: metrics,
        metricChange: rmNumberFormat(d.data),
        title: d.label
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'dashboard-schedule-chart-tooltip';
  $scope.prepareChartData = function (data) {
    return chartDashboardScheduleService.prepareData(data);
  };
  function updateCarousel() {
    $rootScope.$broadcast('reload-carousel');
  }
  $scope.reloadChart = function () {
    chartDashboardScheduleDataService.getData().then($scope.prepareChartData).then($scope.renderChart).then(updateCarousel);
  };
  $scope.checkVisibilityAndReload = function () {
    var isVisible = dashboardCommonService.isOneMarketSelected() && dashboardCommonService.selectionHasData();
    $scope.setChartVisibility(isVisible);
    if (isVisible) {
      $scope.reloadChart();
    }
  };
};
ChartDashboardScheduleController.$inject = ['$scope', '$rootScope', '$filter', 'ChartDashboardScheduleDataService', 'ChartDashboardScheduleService', 'DashboardCommonService'];
module.exports = ChartDashboardScheduleController;